import { RefObject } from 'react';

export const scrollTo = (ref: RefObject<HTMLDivElement> | null) => {
    if (ref && ref.current) {
        ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};
